import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { BrComponent } from '@bloomreach/react-sdk';
import { generateConditionalClassNames } from '../utils/utils.js';

var CmsRowPDPContainer = ({ component  })=>{
    const _ref = component.getParameters(), { showInDesktop , showInTablet , showInPhone , fullWidth , tabButtonTitle  } = _ref, cssStyles = swcHelpers.objectWithoutProperties(_ref, [
        "showInDesktop",
        "showInTablet",
        "showInPhone",
        "fullWidth",
        "tabButtonTitle"
    ]);
    const filteredStyles = Object.fromEntries(Object.entries(cssStyles).filter(([_, value])=>value !== ''
    ));
    const rowClassName = generateConditionalClassNames('br-row-pdp', {
        fullWidth,
        showInDesktop,
        showInTablet,
        showInPhone
    });
    return /*#__PURE__*/ React__default.createElement("div", {
        className: rowClassName,
        "data-t": "br-row-pdp",
        style: swcHelpers.objectSpread({}, filteredStyles)
    }, /*#__PURE__*/ React__default.createElement(BrComponent, null));
};
var CmsRowPDPContainer$1 = CmsRowPDPContainer;

export { CmsRowPDPContainer, CmsRowPDPContainer$1 as default };
//# sourceMappingURL=RowPDPContainer.js.map
